import mainCaller from './mainCaller';

// 지점 스케줄 화면 설정 — 시간 단위·카드 최소 높이·요약 카운트 노출·구분별 기본 수업 시간/강의실.
// 캘린더 시작·종료 시각은 기존 지점 시간 설정 API(center-branch getBranchTime/updateBranchTime)가 따로 맡는다.

// GET /admin/api/v1/branch-schedule-settings?branchId= (저장된 행이 없으면 서버가 기본값을 돌려준다)
export const getBranchScheduleSetting = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/branch-schedule-settings?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// PUT /admin/api/v1/branch-schedule-settings?branchId=
export const updateBranchScheduleSetting = async (branchId, data, token) => {
  return await mainCaller(`admin/api/v1/branch-schedule-settings?branchId=${branchId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};

// 그룹 스케줄 화면 설정 — 지점 스케줄 설정과 따로 저장한다.
// GET /admin/api/v1/branch-schedule-settings/group?branchId=
// → { branchId, timeUnitMinutes, snapMinutes, cardMinMinutes, calendarStartTime, calendarEndTime, defaultRoomId,
//     sharedCalendarStartTime, sharedCalendarEndTime }  (calendarStart/End null = 지점 공용 시간 사용)
export const getGroupScheduleSetting = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/branch-schedule-settings/group?branchId=${branchId}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

// PUT /admin/api/v1/branch-schedule-settings/group?branchId=
export const updateGroupScheduleSetting = async (branchId, data, token) => {
  return await mainCaller(`admin/api/v1/branch-schedule-settings/group?branchId=${branchId}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  });
};
